// extracted by css-extract-rspack-plugin
export default {"windowingSection":"oSJWomNcGcMZSiuj","labelRow":"NQPQBGBjO4A9iuF2","windowingContent":"YzZHHty4Qvwg3d73","helpText":"gEbdSL1tzwE2ZxXV"};